"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LineChartMini = void 0;
const core_1 = require("flow-connect/core");
const ui_1 = require("flow-connect/ui");
class LineChartMini extends core_1.Node {
    constructor() {
        super();
    }
    setupIO() {
        this.addTerminals([{ type: core_1.TerminalType.IN, name: "data", dataType: "array" }]);
    }
    created(options) {
        const { width = 150, name = "Line Chart Mini", style = {}, state = {}, displayHeight = 100, displayStyle = {}, } = options;
        this.displayHeight = displayHeight;
        this.width = width;
        this.name = name;
        this.style = Object.assign({ rowHeight: 10 }, style);
        this.state = Object.assign(Object.assign({}, LineChartMini.DefaultState), state);
        this.setupUI(displayStyle);
    }
    process() { }
    setupUI(displayStyle) {
        let display = this.createUI("core/display", {
            clear: true,
            height: this.displayHeight,
            customRenderers: [
                {
                    auto: true,
                    clear: true,
                    renderer: (ctx, wdth, hght) => this.customRenderer(ctx, wdth, hght),
                },
            ],
            style: displayStyle ? displayStyle : {},
        });
        this.ui.append(display);
        let sizeInput = this.createUI("core/input", {
            propName: "size",
            input: true,
            output: true,
            height: 20,
            style: { type: ui_1.InputType.Number, grow: 0.5 },
        });
        this.ui.append(this.createUI("core/x-layout", {
            childs: [this.createUI("core/label", { text: "Size" }), sizeInput],
            style: { spacing: 20 },
        }));
    }
    customRenderer(context, wdth, hght) {
        let data = this.getInputs();
        if (!data || !data[0])
            return true;
        data[0].forEach((input, index) => {
            if (!input)
                return;
            let spacing = Number((wdth / (this.state.size - 1)).toFixed(2));
            context.strokeStyle = this.state.colors[index] || core_1.Color.Random().rgbaCSSString;
            context.lineWidth = 2;
            context.beginPath();
            context.moveTo(0, (1 - input[0]) * hght);
            for (let i = 1; i < input.length; i += 1)
                context.lineTo(i * spacing, (1 - input[i]) * hght);
            context.stroke();
        });
        return true;
    }
    serialize(persist) {
        const _super = Object.create(null, {
            serialize: { get: () => super.serialize }
        });
        return __awaiter(this, void 0, void 0, function* () {
            const serializedNode = (yield _super.serialize.call(this, persist));
            serializedNode.displayHeight = this.displayHeight;
            return serializedNode;
        });
    }
}
exports.LineChartMini = LineChartMini;
LineChartMini.DefaultState = { size: 10, colors: [""] };
